// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"6":"af2fe900","299":"e545f5ba","547":"b622d31a","746":"c3cccc26","788":"753fedec","836":"06fc1518","839":"da3b2de4"}[chunkId] + ".chunk.js";
};